import React from "react";

import CloseIcon from "@material-ui/icons/Close";
import {IconButton, Button } from "@material-ui/core";

const ConfirmationModal = ({title, onClose, onAction }) => {
  return (
    <div className="modal-container">
      <div className="modal-container-top">
        <h2>{title}</h2>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Button variant="contained" color="primary" className="form-btn" onClick={() => onAction()}>
        Yes
      </Button>
    </div>
  );
};
export default ConfirmationModal;
